import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.section`
  display: flex;
  padding: 16px;
`;

export const AcceptButton = styled(Button)`
  margin-left: 16px;
`;

export const TextModal = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.DimGray};

  & > strong {
    font-weight: 600;
  }
`;
